module.exports = __webpack_public_path__ + "img/selected1-min.be6f4a07.png";